// routes/index.jsx
import { lazy } from "react";
import { useRoutes } from "react-router-dom";
import LazyRoute from "../components/Common/LazyRoute";
import ProtectedRoute from "../ProtectedRoute";
import ROUTES from "./ROUTES";

import addonsRoutes from "./addons.routes";
import authRoutes from "./auth.routes";
import workspaceRoutes from "./workspace.routes";
import billingRoutes from "./billing.routes";
import customerRoutes from "./customer.routes";
import dashboardRoutes from "./dashboard.routes";
import emailRoutes from "./email.routes";
import miscRoutes from "./misc.routes";
import orderRoutes from "./order.routes";
import paymentRoutes from "./payment.routes";
import supportRoutes from "./support.routes";
import ExposedAPIV2 from "@/pages/Documentation/ExposedAPI-v2";
import ExposedAPI from "@/pages/Documentation/ExposedAPI";
import SupportRequestPage from "@/components/Addon/Support/SupportRequestPage";
import HelpGuides from "@/components/Support/User/HelpGuides"

const App = lazy(() => import("../components/app")); // the layout with sidebar
const FileDownloadPage = lazy(() => import("../pages/Download/FileDownloadPage"));

export default function AppRoutes() {
  return useRoutes([
    // Public / Auth area (no sidebar)
    ...authRoutes,

    // Public routes - accessible without login
    { path: ROUTES.API_DOCS, element: <LazyRoute><ExposedAPIV2 /></LazyRoute> },
    { path: ROUTES.OLD_EXPOSED_API, element: <LazyRoute><ExposedAPI /></LazyRoute> },
    { path: ROUTES.SUPPORTWITHOUTLOGIN, element: <LazyRoute><SupportRequestPage /></LazyRoute> },
    { path: ROUTES.SUPPORT.HELP_GUIDES_OUTSIDE, element: <LazyRoute><HelpGuides /></LazyRoute> },
    // Handles its own login check so it can send the user back here after login.
    { path: ROUTES.DOWNLOAD_LINK, element: <LazyRoute><FileDownloadPage /></LazyRoute> },

    // ✅ Main App Routes - wrapped with ProtectedRoute and App (sidebar/layout)
    {
      path: ROUTES.ROOT,
      element: (
        <ProtectedRoute element={<><App /></>} />
      ),
      children: [
        ...dashboardRoutes,
        ...orderRoutes,
        ...customerRoutes,
        ...billingRoutes,
        ...supportRoutes,
        ...addonsRoutes,
        ...paymentRoutes,
        ...miscRoutes,
        ...emailRoutes,
        ...workspaceRoutes,
      ],
    },
  ]);
}
